










import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ButtonLoader extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/button/components/loader/ButtonLoader.vue